import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, CardHeader, CardBody, Container } from 'reactstrap'
import { ApiRequestBuilder } from '../../GlobalComponents/Builders';
import { AccountContext } from '../../GlobalComponents/Authentication/Accounts';
import { useContext } from 'react';

const ToolsList = () => {
    
    const { userSession } = useContext(AccountContext);

    const [availableToolData, setAvailableToolData] = useState([]);
    const [subscribedToolData, setSubscribedToolData] = useState([]);
    const [disabledToolData, setDisabledToolData] = useState([]);

    const accessLevelFilter = localStorage.getItem('accessLevel') === 'global'

    useEffect(() => {

        document.title = 'View Tools'

        ApiRequestBuilder('toolsGet').then(function(results) {

            if (results.data && results.data.length > 0)
            {
                setAvailableToolData(results.data.filter(tool => !tool.partner_id).filter(tool => !accessLevelFilter ? tool.is_active : true))
                setSubscribedToolData(accessLevelFilter ? results.data.filter(tool => tool.partner_id) : results.data.filter(tool => String(tool.partner_id) === userSession['custom:partnerId']).filter(tool => !accessLevelFilter ? tool.is_active : true))
            }
        })
    }, []);

    return (
        <Fragment>
                <Row>
                    {
                        availableToolData.length > 0 || subscribedToolData.length > 0 ? <Fragment>
                        {/* For partner users: show their partner tools first, seamlessly */}
                        {!accessLevelFilter && subscribedToolData.length > 0 && (
                          <Row>
                            {subscribedToolData.map(data => (
                              <Col md="4" className="mb-4 d-flex" key={data.tool_id}>
                                <Card className="w-100 h-100 d-flex flex-column">
                                  <CardHeader className="text-center">
                                    <h5 className="mb-2">
                                      {data.route ? (
                                        <Link to={`${process.env.PUBLIC_URL}/tools/${data.route}`}>{data.name}</Link>
                                      ) : (
                                        data.name
                                      )}
                                    </h5>
                                  </CardHeader>
                                  <CardBody className="flex-grow-1 text-center">
                                    <p className="mb-0">{data.description}</p>
                                  </CardBody>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        )}
                        <Container>
                            <Card>
                                <CardBody className="flex-grow-1 text-center">
                                    <h4>{accessLevelFilter ? 'All Available Tools' : 'Tools'}</h4>
                                </CardBody>
                            </Card>
                        </Container>
                        <Row>
                          {availableToolData.map(data => (
                            <Col md="4" className="mb-4 d-flex" key={data.tool_id}>
                              <Card className="w-100 h-100 d-flex flex-column">
                                <CardHeader className="text-center">
                                  <h5 className="mb-2">
                                    {data.route ? (
                                      <Link to={`${process.env.PUBLIC_URL}/tools/${data.route}`}>{data.name}</Link>
                                    ) : (
                                      data.name
                                    )}
                                  </h5>
                                </CardHeader>
                                <CardBody className="flex-grow-1 text-center">
                                  <p className="mb-0">{data.description}</p>
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      
                        {/* For global users: show partner tools in a separate section for management */}
                        {accessLevelFilter && subscribedToolData.length > 0 && (
                          <>
                            <Container>
                                <Card>
                                    <CardBody className="flex-grow-1 text-center">
                                        <h4>Partner Specific Tools</h4>
                                    </CardBody>
                                </Card>
                            </Container>
                            <Row>
                              {subscribedToolData.map(data => (
                                <Col md="4" className="mb-4 d-flex" key={data.tool_id}>
                                  <Card className="w-100 h-100 d-flex flex-column">
                                    <CardHeader className="text-center">
                                      <h6 className="mb-1">{data.partner.name}</h6>
                                      <h5 className="mb-2">
                                        {data.route ? (
                                          <Link to={`${process.env.PUBLIC_URL}/tools/${data.route}`}>{data.name}</Link>
                                        ) : (
                                          data.name
                                        )}
                                      </h5>
                                    </CardHeader>
                                    <CardBody className="flex-grow-1 text-center">
                                      <p className="mb-0">{data.description}</p>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                            </Row>
                          </>
                        )}
                      </Fragment>
                       : <p>Loading Tools List...</p>
                    } 
                </Row>
        </Fragment>
    );
};
export default ToolsList;